
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class SysGroupGrid extends Serenity.EntityGrid<SysGroupRow, any> {
        protected getColumnsKey() { return SysGroupColumns.columnsKey; }
        protected getDialogType() { return SysGroupDialog; }
        protected getIdProperty() { return SysGroupRow.idProperty; }
        protected getInsertPermission() { return SysGroupRow.insertPermission; }
        protected getLocalTextPrefix() { return SysGroupRow.localTextPrefix; }
        protected getService() { return SysGroupService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}